import { render } from "./WCCartDrawer.vue?vue&type=template&id=11d47453&scoped=true"
import script from "./WCCartDrawer.vue?vue&type=script&lang=js"
export * from "./WCCartDrawer.vue?vue&type=script&lang=js"

import "./WCCartDrawer.vue?vue&type=style&index=0&id=11d47453&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d47453"]])

export default __exports__